import React from 'react';

const GameSetupOverlay = ({ onSelectServer, onClose, player1Name = 'Player 1', player2Name = 'Player 2', opponentName }) => {
  const p1 = player1Name || 'Player 1';
  const p2 = player2Name || opponentName || 'Player 2';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-6 rounded-2xl shadow-2xl max-w-sm w-full border border-gray-100 text-center animate-fade-in">
        <div className="w-12 h-12 rounded-full bg-green-50 text-green-600 flex items-center justify-center mx-auto mb-3 text-2xl">
          🎾
        </div>
        <h2 className="text-xl font-bold mb-2 text-gray-800">Who serves first?</h2>
        <p className="text-sm text-gray-600 mb-6">Select the player who will serve first in this match:</p>
        <div className="flex flex-col gap-3">
          <button
            onClick={() => { onSelectServer('me'); onClose(); }}
            className="w-full bg-green-600 text-white font-bold py-3 px-4 rounded-xl hover:bg-green-700 active:scale-[0.98] transition-all shadow-md flex items-center justify-center gap-2"
          >
            <span>🟢</span>
            <span>{p1}</span>
          </button>
          <button
            onClick={() => { onSelectServer('opponent'); onClose(); }}
            className="w-full bg-rose-600 text-white font-bold py-3 px-4 rounded-xl hover:bg-rose-700 active:scale-[0.98] transition-all shadow-md flex items-center justify-center gap-2"
          >
            <span>🔴</span>
            <span>{p2}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameSetupOverlay;
